import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

function PaymentFailed() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const txnId = searchParams.get('txnid');

  return (
    <Layout>
      <div className='page-container'>
        <div className='card reveal reveal-up shimmer-border' style={{ textAlign: 'center', position: 'relative' }}>
          <div style={{ fontSize: '4rem', marginBottom: '0.5rem', animation: 'floatSoft 2.5s ease-in-out infinite' }}>😔</div>
          <h1 className='page-title'>Payment Failed</h1>

          <p style={{ marginTop: '0.5rem', color: '#dc2626', fontWeight: 600, fontSize: '1.05rem' }}>
            Unfortunately, your payment could not be processed.
          </p>

          {txnId && (
            <div style={{
              marginTop: '1rem', padding: '0.75rem 1rem', borderRadius: '0.75rem',
              background: 'rgba(241,245,249,.8)', border: '1px solid rgba(226,232,240,.5)',
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            }}>
              <span style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 600 }}>Transaction ID:</span>
              <span style={{ fontSize: '0.85rem', color: '#0f172a', fontWeight: 700, fontFamily: "'Courier New', monospace" }}>{txnId}</span>
            </div>
          )}

          <hr />

          <div className="reveal reveal-up" style={{ transitionDelay: '100ms' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <span>❓</span> What Happened?
            </h3>
            <p style={{ color: '#64748b', marginTop: '0.5rem' }}>
              Your payment was declined or cancelled. This could be due to:
            </p>
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '0.75rem', marginTop: '1rem', textAlign: 'left',
            }}>
              {[
                { icon: '💰', text: 'Insufficient funds' },
                { icon: '🏦', text: 'Card declined by bank' },
                { icon: '⏰', text: 'Transaction timeout' },
                { icon: '🚫', text: 'You cancelled the payment' },
              ].map((item) => (
                <div key={item.text} style={{
                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                  padding: '0.625rem 0.75rem', borderRadius: '0.75rem',
                  background: 'rgba(241,245,249,.7)', border: '1px solid rgba(226,232,240,.4)',
                  fontSize: '0.85rem', color: '#475569',
                }}>
                  <span>{item.icon}</span> {item.text}
                </div>
              ))}
            </div>
          </div>

          <hr />

          <div className="reveal reveal-up" style={{ transitionDelay: '200ms' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <span>🔄</span> What Next?
            </h3>
            <p style={{ color: '#64748b', marginTop: '0.5rem' }}>
              You can try again or contact support if you need help.
            </p>

            <button
              className='btn btn-primary mt-2'
              onClick={() => navigate('/download')}
            >
              🔄 Try Again
            </button>
          </div>

          <hr />

          <a href='mailto:support@syntriq.in' style={{ textDecoration: 'none' }}>
            <p style={{ fontSize: '0.9rem', color: '#64748b', transition: 'color 0.3s' }}>
              Need help? Contact <strong style={{ color: '#2563eb' }}>support@syntriq.in</strong>
            </p>
          </a>
        </div>
      </div>
    </Layout>
  );
}

export default PaymentFailed;
